
const setStateAsync = (callback)=>{
        setTimeout(callback,200)
    }

export default setStateAsync;    